/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Active_Accounts_HintInputs */

const en_admin_user_list_active_accounts_hint = /** @type {(inputs: Admin_User_List_Active_Accounts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active = created or used in the current calendar year.`)
};

const de_admin_user_list_active_accounts_hint = /** @type {(inputs: Admin_User_List_Active_Accounts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv = im laufenden Kalenderjahr erstellt oder genutzt.`)
};

/**
* | output |
* | --- |
* | "Active = created or used in the current calendar year." |
*
* @param {Admin_User_List_Active_Accounts_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_active_accounts_hint = /** @type {((inputs?: Admin_User_List_Active_Accounts_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Active_Accounts_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_active_accounts_hint(inputs)
	return en_admin_user_list_active_accounts_hint(inputs)
});